import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { Badge, Card, Spinner } from '../../components/ui';
import { api } from '../../lib/api';
import { formatDateTime } from '../../lib/formatters';

export function EventDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['event', id],
    queryFn: async () => (await api.get(`/admin/events/${id}`)).data,
    enabled: !!id,
  });

  if (isLoading) return <Spinner />;
  if (!data) return <div>Not found</div>;

  return (
    <div className="space-y-6">
      <Link to="/admin/events" className="text-sm text-ink-muted underline">
        ← Back to events
      </Link>

      <div>
        <h1 className="font-display text-3xl">{data.title}</h1>
        <div className="flex items-center gap-2 mt-1">
          <Badge>{data.type}</Badge>
          <Badge variant={data.status === 'PUBLISHED' ? 'success' : 'default'}>{data.status}</Badge>
        </div>
      </div>

      <Card className="p-5 space-y-2">
        <div>
          <span className="text-ink-muted">When:</span> {formatDateTime(data.startTime)} — {formatDateTime(data.endTime)}
        </div>
        {data.location && (
          <div>
            <span className="text-ink-muted">Where:</span> {data.location}
          </div>
        )}
        <div>
          <span className="text-ink-muted">Seats:</span>{' '}
          {data.maxSeats ? `${data._count?.registrations ?? 0} / ${data.maxSeats}` : 'Unlimited'}
        </div>
      </Card>

      {/* TODO(section-4): registrations panel, waitlist panel, tables panel (T-4.9), audit trail */}
    </div>
  );
}
